function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 14.5,
  y1: 94.5,
  x2: 14.5,
  y2: 65
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 10.3,
  y1: 55.4,
  x2: 67,
  y2: 55.4
}), React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 58.3,
  y1: 66.6,
  x2: 83,
  y2: 66.6
}), React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 58.3,
  y1: 69.6,
  x2: 83,
  y2: 69.6
}), React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 58.3,
  y1: 72.6,
  x2: 78,
  y2: 72.6
}), React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 58.3,
  y1: 78.6,
  x2: 83,
  y2: 78.6
}), React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 58.3,
  y1: 81.6,
  x2: 83,
  y2: 81.6
}), React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 58.3,
  y1: 84.6,
  x2: 83,
  y2: 84.6
}), React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 58.3,
  y1: 87.6,
  x2: 67,
  y2: 87.6
}), React.createElement("rect", {
  x: 6.4,
  y: 50.9,
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  width: 86.5,
  height: 49.2
}));

var _ref4 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#0F63F2",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 14.5,
  y1: 94.5,
  x2: 14.5,
  y2: 76
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 20.5,
  y1: 94.5,
  x2: 20.5,
  y2: 65
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 20.5,
  y1: 94.5,
  x2: 20.5,
  y2: 81
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 26.5,
  y1: 94.5,
  x2: 26.5,
  y2: 65
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 26.5,
  y1: 94.5,
  x2: 26.5,
  y2: 85
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 32.5,
  y1: 94.5,
  x2: 32.5,
  y2: 65
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 32.5,
  y1: 94.5,
  x2: 32.5,
  y2: 81
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 38.5,
  y1: 94.5,
  x2: 38.5,
  y2: 65
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 38.5,
  y1: 94.5,
  x2: 38.5,
  y2: 90
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 44.5,
  y1: 94.5,
  x2: 44.5,
  y2: 65
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 44.5,
  y1: 94.5,
  x2: 44.5,
  y2: 85
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 50.5,
  y1: 94.5,
  x2: 50.5,
  y2: 65
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 50.5,
  y1: 94.5,
  x2: 50.5,
  y2: 87
});

var SvgPresentation = function SvgPresentation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 150",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPresentation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/presentation.c64ce0d1.svg";
export { ForwardRef as ReactComponent };